import { createContext, useContext, useEffect, useState } from "react";

const PermissionContext = createContext(null);

export const AuthPermissionProvider = ({ children }) => {
    const [hasPProEnabled, setHasPProEnabled] = useState(0);
    const [hasSubscriptionMerchantId, setHasSubscriptionMerchantId] = useState(0);
    const [hasGCLSubscriptionEnabled, setHasGCLSubscriptionEnabled] = useState(0);
    const [haspbInvoiceEnabled, setHaspbInvoiceEnabled] = useState(0);

    useEffect(() => {
        const stored = Number(localStorage.getItem("ppro_enabled"));
        if (!Number.isNaN(stored)) {
            setHasPProEnabled(stored);
        }

        const storedSubscription = localStorage.getItem("subscription_merchant_id");
        setHasSubscriptionMerchantId(storedSubscription ? 1 : 0);

        const storedpbInvoiceEnabled = localStorage.getItem("pb_invoice_enabled");
        setHaspbInvoiceEnabled(storedpbInvoiceEnabled ? 1 : 0);

        const storedGCLSubscription = Number(localStorage.getItem("gcl_subscription_enabled"));
        if (!Number.isNaN(storedGCLSubscription)) {
            setHasGCLSubscriptionEnabled(storedGCLSubscription);
        }

    }, []);

    return (
        <PermissionContext.Provider value={{ hasPProEnabled, setHasPProEnabled, hasSubscriptionMerchantId, setHasSubscriptionMerchantId, hasGCLSubscriptionEnabled, setHasGCLSubscriptionEnabled, haspbInvoiceEnabled, setHaspbInvoiceEnabled }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionContext);
